import { MODULES } from "../../../../utils/constants";
import { routes } from "../../../../constants/routes";
import icons from "../../../../assets/icons/valid-icons"

export interface MenuItem {
  label: string;
  icon?: string;
  path: string;
  subMenu?: MenuItem[];
  classNames: string;
  isOpen?: boolean;
  disabled?: boolean;
  moduleName?: string;
  isModuleEnabled?: boolean;
  permissionRole?: any[];
  onlyShowTOAFP?: boolean;
  navbarItem?: boolean;
}

export interface SidebarProps {
  menuItems: MenuItem[];
  footerItems: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    label: "Dashboard",
    icon: icons.DashboardIcon,
    path: routes.ADMIN_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Profile Management",
    icon: icons.ProfileIcon,
    path: routes.ADMIN_PROFILE_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Provider Management",
    icon: icons.ProviderManagementIcon,
    path: routes.PROVIDER_MANAGEMENT,
    classNames: "",
    navbarItem: false,
    subMenu: [
      {
        label: "Provider Profile",
        icon: "",
        path: routes.PROVIDER_PROFILES,
        moduleName: MODULES.PROVIDER_PROFILES,
        classNames: "",
      },
      {
        label: "Registration Requests",
        icon: "",
        path: routes.PROVIDER_REQUESTS,
        moduleName: MODULES.PROVIDER_REQUESTS,
        classNames: "",
      }
    ]
  },
  {
    label: "Planner Management",
    icon: icons.ProviderManagementIcon,
    path: routes.PLANNER_MANAGEMENT,
    classNames: "",
    navbarItem: false,
    subMenu: [
      {
        label: "Planner Profile",
        icon: "",
        path: routes.PLANNER_PROFILES,
        moduleName: MODULES.PLANNER_PROFILES,
        classNames: "",
      },
      {
        label: "Registration Requests",
        icon: "",
        path: routes.PLANNER_REQUESTS,
        moduleName: MODULES.PLANNER_REQUESTS,
        classNames: "",
      }
    ]
  },
  {
    label: "Service Management",
    icon: icons.ServiceManagementIcon,
    path: routes.SERVICE_LIST,
    classNames: "",
    navbarItem: false,
    subMenu: [
      {
        label: "Service List",
        icon: "",
        path: routes.SERVICE_LIST,
        moduleName: MODULES.SERVICE_LIST,
        classNames: "",
      }
    ]
  },
  {
    label: "User Management",
    icon: icons.UserManagementIcon,
    path: routes.ADMIN_USER_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Support Requests",
    icon: icons.CommunicationManagementIcon,
    path: routes.ADMIN_COMMUNICATION_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Order Management",
    icon: icons.OrderManagementIcon,
    path: routes.ADMIN_ORDER_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },
]

export const footerItems: MenuItem[] = [
  {
    label: "Terms of Service",
    icon: icons.TermsOfServiceIcon,
    path: routes.ADMIN_TERMS_OF_SERVICE,
    classNames: "",
    navbarItem: false,
  },
]

